__turbopack_context__.v({
  "links": "index-module__JotL0q__links",
});
